<template>
  <div class="province">
    <label class="title" :style="`margin-left: ${fenceStatus === 'edit'? '5px' : '35px'}`">{{$t('supervise.selectDistrict')}}：</label>
    <a-cascader class="select" :placeholder="$t('supervise.selectDistrict')" :defaultValue="selectRegions" :options="regions" @change="onRegionChange"
      :loadData="loadData" changeOnSelect />
  </div>
</template>
<script>
import config from '../../config/'
export default {
  data () {
    return {
      regions: [],
      selectRegions: [],
      overlays: [],
      bdary: null,
      drawData: {}
    }
  },
  props: {
    map: {
      required: true
    },
    fenceStatus: {
      default: 'add'
    }
  },
  methods: {
    // 初始化获取所有省的id
    init () {
      this.$http.post(config.api.get_all_province_id).then((response) => {
        if (response.code == 0) {
          this.regions = []
          response.result.map((item) => {
            this.regions.push({
              value: item.id + ',' + item.name,
              label: item.name,
              isLeaf: false,
            })
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 当选择框做出级联选择时，动态获取下级数据(省 --- 市 -- 县 --- 区) 最多三级
    // 参数为当前选择的地区
    loadData(selectedOptions) {
      // console.log(selectedOptions)
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      let param = {}
      param.id = targetOption.value.split(',')[0]
      this.$http.post(config.api.get_all_province_id, param).then((response) => {
        if (response.code == 0) {
          targetOption.loading = false;
          targetOption.children = []
          response.result.map((item) => {
            targetOption.children.push({
              value: item.id + ',' + item.name,
              label: item.name,
              isLeaf: item.level < 3 ? false : true
            })
          })
          this.regions = [...this.regions]
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 选择改变事件
    onRegionChange(region) {
      // console.log(region)
      this.selectRegions = region
      if (region && region.length > 0) {
        this.bdary.get(region[region.length - 1].split(',')[1], (rs) => { //获取行政区域
          // console.log(rs)
          for (let i = 0; i < this.overlays.length; i++) {
            this.map.removeOverlay(this.overlays[i])
          }
          this.clearOverlays()
          let count = rs.boundaries.length; //行政区域的点有多少个
          let points = []
          for (let i = 0; i < count; i++) {
            let overlay = new BMap.Polygon(rs.boundaries[i], {
              strokeWeight: 3,
              strokeColor: "red"
            }) //建立多边形覆盖物
            this.map.addOverlay(overlay) //添加覆盖物
            this.overlays.push(overlay)
            points.push([...overlay.getPath(), overlay.getPath()[0]])
          }
          this.map.setViewport(points[0]);
          this.drawData = {
            type: 'district',
            parameter: {
              points: [
                ...points
              ]
            }
          }
          // console.log(this.drawData)
          this.$emit('provinceData', this.drawData)
        });
      } else {
        this.clearOverlays()
      }
    },
    clearOverlays() {
      this.overlays = []
    }
  },
  created () {
    this.init()
    this.bdary = new BMap.Boundary()
  },
  mounted () {
    console.log(this.fenceStatus)
  }
}
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.province {
  margin: 5px 0;
  .select {
    width: 270px;
  }
  .title {
    // color: #999;
    // margin-left: 5px;
    color: @heading-color;
  }
}
</style>
